import Vue from 'vue';
import Vuex from 'vuex';
import {remove} from 'lodash-es';

Vue.use(Vuex);

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
export const GET_POLLS = 'GET_POLLS';
export const GET_SURVEYS = 'GET_SURVEYS';
export const GET_ITEMS = 'GET_ITEMS';
export const GET_VOTES = 'GET_VOTES';
export const GET_AVG = 'GET_AVG';

export const SET_POLL = 'SET_POLL';
export const SET_SURVEY = 'SET_SURVEY';
export const SET_ITEM = 'SET_ITEM';
export const SET_VOTE = 'SET_VOTE';
export const SET_AVG = 'SET_AVG';

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
// VUEX STORE                                                                                //
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
const store = new Vuex.Store({
    /* eslint-disable no-undef */
    strict: process.env.NODE_ENV !== 'production',
    /* eslint-enable no-undef */
    state: {
        items: [],
        polls: [],
        surveys: [],
        votes: [],
        avg: []
    },
    mutations: {
        [SET_POLL](state, poll) {
            state.polls.push(poll);
        },
        [SET_SURVEY](state, survey) {
            state.surveys.push(survey);
        },
        [SET_ITEM](state, item) {
            state.items.push(item);
        },
        [SET_VOTE](state, vote) {
            state.votes.push(vote);
        },
        [SET_AVG]: (state, avg) => {
            remove(state.avg, a => {
                return a.items === avg.items && a.item === avg.item
            })
            state.avg.push(avg)
        }
    },
    getters: {
        [GET_POLLS]: state => state.polls,
        [GET_SURVEYS]: state => state.surveys,
        [GET_ITEMS]: state => state.items,
        [GET_VOTES]: state => state.votes,
        [GET_AVG]: state => state.avg
    },
});

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
// EXPORTS                                                                                   //
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
export default store;

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - //
